import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { Actions, Store, ofActionSuccessful } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RobotFamilyMetadata } from 'src/app/models/robot-family-metadata';
import { LoadMetadataSuccess, RobotFamilyMetadataState } from '../../../redux';
import { ViewRobotFamilyMetadataComponent } from '../view-robot-family-metadata.component';

@Component({
  selector: 'app-modal-container-robot-family-metadata',
  template: ''
})
export class ModalContainerRobotFamilyMetadataComponent implements OnDestroy, OnInit {
  public robotfamilymetadata$: Observable<RobotFamilyMetadata[] | undefined> = inject(Store).select(
    RobotFamilyMetadataState.robotFamilyMetadata
  );
  private unsubscribe = new Subject<void>();

  public tableData?: RobotFamilyMetadata[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: NbDialogService,
    private actions$: Actions
  ) {}

  public ngOnInit() {
    this.robotfamilymetadata$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.tableData = data));
    this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe((params) => {
      if (this.tableData) {
        const found = this.tableData.find((element) => element.robot_family === params.id);
        if (found) {
          this.dialogService
            .open(ViewRobotFamilyMetadataComponent, {
              closeOnEsc: false,
              closeOnBackdropClick: false,
              context: {
                metadata: RobotFamilyMetadata.copy(found)
              }
            })
            .onClose.subscribe(() => {
              this.router.navigateByUrl('robot-family-metadata/table');
            });
        } else {
          this.router.navigateByUrl('robot-family-metadata/table');
        }
      } else {
        this.actions$.pipe(ofActionSuccessful(LoadMetadataSuccess), takeUntil(this.unsubscribe)).subscribe(() => {
          const found = this.tableData.find((element) => element.robot_family === params.id);
          if (found) {
            this.dialogService
              .open(ViewRobotFamilyMetadataComponent, {
                closeOnEsc: false,
                closeOnBackdropClick: false,
                context: {
                  metadata: RobotFamilyMetadata.copy(found)
                }
              })
              .onClose.subscribe(() => {
                this.router.navigateByUrl('robot-family-metadata/table');
              });
          } else {
            this.router.navigateByUrl('robot-family-metadata/table');
          }
        });
      }
    });
  }

  public ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
